export enum NetaxeptFinalizeResponseCode
{
    Ok = 1,
    Failed = 2,
    RefusedByIssuer = 59,
    AlreadyProcessed = 98,
    UnableToAuth = 99
}
